import axios from "axios";
import { API_ENDPOINTS } from "../../config";

const normalizeToken = (t) => {
  const raw = String(t ?? "").trim();
  if (!raw) return "";
  return raw.replace(/^Bearer\s+/i, "").trim();
};

let cachedWorkingUrl = null;

async function onlinePing(token) {
  const raw = normalizeToken(token ?? localStorage.getItem("JWToken"));
  if (!raw) return null;

  const url = cachedWorkingUrl || API_ENDPOINTS.ONLINEPING || API_ENDPOINTS.ONLINE_PING;
  if (!url) throw new Error("Missing ONLINEPING endpoint in API_ENDPOINTS");

  try {
    const response = await axios.put(url, null, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${raw}`
      }
    });

    cachedWorkingUrl = url;
    return response.status;
  } catch (error) {
    const status = error?.response?.status;

    if (cachedWorkingUrl === url) {
      cachedWorkingUrl = null;
    }

    if (status === 404) return null;

    console.error("Online ping failed:", error);
    throw error;
  }
}

export default onlinePing;